import { AuthorizationRedirectManager } from './authorization-redirect-manager';
import { Router, NavigationInstruction, RouteConfig, NavigationInstructionInit } from 'aurelia-router';
import { mock } from 'ts-mockito';

describe('NewPortalWeb', () => {
	describe('helpers', () => {
		describe('authorization-redirect-manager', () => {
			let component: AuthorizationRedirectManager;
			let navigationInit: NavigationInstructionInit;
			let navigationInstruction: NavigationInstruction;
			const mockRouter: Router = mock(Router);

			// Initialize Component and NavigationInstruction
			beforeEach(() => {
				component = new AuthorizationRedirectManager();
				let config = { route: 'test/route', name: 'test' };
				let params = { id: '1' };
				navigationInit = { fragment: '', router: mockRouter, config, params };
				// using instaniated instance to cleanly add router, config and params properties that all get used
				navigationInstruction = new NavigationInstruction(navigationInit);
				spyOn(mockRouter, 'generate').and.returnValue('test/route');
			});

			it('should handle not authorized and preAuthUri should be generated from navigationInstruction', () => {
				let loginUri: string = component.handleNotAuthorized(navigationInstruction);
				let savedNavigationInstruction: NavigationInstruction = component.NavigationInstruction;

				expect(savedNavigationInstruction).toEqual(navigationInstruction);
				expect(loginUri).toEqual(`portal/${savedNavigationInstruction.params.id}/login`);

				let preAuthUri = component.getPreAuthUri();
				expect(preAuthUri).toBe('test/route');

				// getPreAuthUri() should set navigationInstruction to null
				savedNavigationInstruction = component.NavigationInstruction;
				expect(savedNavigationInstruction).toBeNull();
			});

			it('pre auth uri should be null when navigationInstruction is null', () => {
				let preAuthUri: string = component.getPreAuthUri();
				expect(preAuthUri).toBeNull();
			});
		});
	});
});
